import { useMutation, useQueryClient } from '@tanstack/react-query'
import { DashboardApi } from '@/services/api-routes'
import type { PreferenciaIndicadoresPayload } from '@/types/dashboard'
import { dashboardKeys } from '@/http/queryKeys'
import { notifyErrorFor, notifySuccess } from '@/utility/notify'

export const useAtualizarPreferenciaIndicadoresMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: PreferenciaIndicadoresPayload) =>
      DashboardApi.atualizarPreferenciaIndicadores(payload),
    onSuccess: (_data, { perfil }) => {
      void queryClient.invalidateQueries({ queryKey: dashboardKeys.preferenciaIndicadores(perfil) })
      void queryClient.invalidateQueries({ queryKey: dashboardKeys.indicadores() })
      notifySuccess('Preferência de indicadores atualizada com sucesso!')
    },
    onError: (error) => notifyErrorFor('atualizar a preferência de indicadores', error),
  })
}
